// Empty placeholder layers that fix the draw order regardless of when each
// React layer mounts. Polygon slots sit below the basemap's first symbol layer
// so labels stay legible; point slots sit above everything.
import type { Map as MaplibreMap } from 'maplibre-gl';

export const SLOT = {
  hillCountry: 'slot-hill-country',
  fim: 'slot-fim',
  alerts: 'slot-alerts',
  alertIcons: 'slot-alert-icons',
  gauges: 'slot-gauges',
  stations: 'slot-stations',
  pins: 'slot-pins',
} as const;

const EMPTY_SOURCE = 'slot-empty';

export function installSlots(map: MaplibreMap): void {
  if (!map.getSource(EMPTY_SOURCE)) {
    map.addSource(EMPTY_SOURCE, { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
  }
  const firstSymbol = map.getStyle().layers.find((l) => l.type === 'symbol')?.id;
  const add = (id: string, beforeId?: string) => {
    if (map.getLayer(id)) return;
    map.addLayer({ id, type: 'circle', source: EMPTY_SOURCE, layout: { visibility: 'none' } }, beforeId);
  };
  add(SLOT.hillCountry, firstSymbol);
  add(SLOT.fim, firstSymbol);
  add(SLOT.alerts, firstSymbol);
  // iOS MapContentBuilder order: alert icons, then gauges, stations, pins on top.
  add(SLOT.alertIcons);
  add(SLOT.gauges);
  add(SLOT.stations);
  add(SLOT.pins);
}
